import React, { Component } from 'react'
export default class StateManaGementComponent extends Component {
    state={counter:0}; 
    IncrementCounter= ()=> {
           this.setState({counter:this.state.counter+1});
    }
    render() {
        return (
            <div>
                <button onClick={this.IncrementCounter} >Increment Counter </button><br/>
                <label>Increment  Button is Clicked : <b>{this.state.counter }</b></label> 
            </div>
        )
    }
}
